import { Form } from 'antd';
import { useContext } from 'react';

import { RangePicker } from 'app/components/fields/dayjsPickers';
import {
  formatDayjsToTimeRange,
  formatToDayjs,
} from 'app/components/pages/Experiences/Common/_components/FormItems/OpeningHours/utils';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { Dayjs } from 'app/utils/dayjs';

const RULES = [{ required: true, message: 'Required' }];

export const OpeningHoursConstant = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  return (
    <Form.Item
      name={['openingHours', 'configuration']}
      rules={RULES}
      getValueFromEvent={(dayjsRange: [Dayjs, Dayjs]) =>
        formatDayjsToTimeRange(dayjsRange)
      }
      getValueProps={(value) => {
        if (
          Array.isArray(value) &&
          value.length === 2 &&
          value[0]?.format &&
          value[1]?.format
        ) {
          return { value };
        }

        return {
          value: value ? formatToDayjs(value) : undefined,
        };
      }}
    >
      <RangePicker
        picker="time"
        className="custom-width-picker"
        minuteStep={30}
        format="HH:mm"
        disabled={!isEditMode}
      />
    </Form.Item>
  );
};
